<div class="hp-recent-search-container">
  <div class="search-results">
    <ul>
      <li *ngFor="let recentSearch of recentSearchResult" class="airport-list">
        <a
          (click)="populateRecentSearch(recentSearch)"
          class="d-flex"
          draggable="false"
          href="javascript:void(0);"
          role="link"
        >
          <span class="col-6 col-sm-6 col-md-6 col-xl-6 col-lg-6 pl-0 pr-0">
            <span class="airport-code pl-0 pr-0">
              {{ getFromAirportCode(recentSearch) }}
            </span>
            <span>&nbsp;&nbsp;to&nbsp;&nbsp;</span>
            <span class="airport-code p-0">
              {{ getToAirportCode(recentSearch) }}
            </span>
            <span *ngIf="recentSearch?.selectTripType === 'MULTICITY'">
              &nbsp;(Multi-City)
            </span>
          </span>
          <span
            class="recentDates col-6 col-sm-6 col-md-6 col-xl-6 col-lg-6 p-0 text-right"
          >
            <span class="saved-departure-date">
              {{ getDepartureDate(recentSearch) | date : 'MMM dd' }}
            </span>
            <span *ngIf="recentSearch?.dates?.returnDate">-</span>
            <span class="saved-arrival-date">
              {{ recentSearch?.dates?.returnDate | date : 'MMM dd' }}
            </span>
          </span>
        </a>
      </li>
    </ul>
  </div>
</div>
